var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from "react";
import { H4 } from "@irati/ui/src/Headings";
import { isEmpty } from "lodash";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import Pill from "@irati/ui/src/Pill";
import { ReactTable } from "@irati/ui/src/Table";
import columns from "./columns";
import { HeaderWrapper, PillWrapper } from "../../styled/styled";
import { StyledCard } from "../../../../containers/ReportingV2/styled";
var PAGE_SIZE = 5;
var MostPopularPerks = /** @class */ (function (_super) {
    __extends(MostPopularPerks, _super);
    function MostPopularPerks() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            page: 0,
            limit: PAGE_SIZE
        };
        _this.handlePageChange = function (nextPage) {
            _this.setState({ page: nextPage });
        };
        return _this;
    }
    MostPopularPerks.prototype.render = function () {
        var _a = this.props, perksAndPerksGoMetrics = _a.perksAndPerksGoMetrics, formatMessage = _a.formatMessage, currency = _a.currency;
        var perks = perksAndPerksGoMetrics.perks;
        var count = isEmpty(perks) ? 0 : perks.length;
        var _b = this.state, page = _b.page, limit = _b.limit;
        var pages = Math.ceil(count / limit);
        var isSavingsEnabled = false;
        return (React.createElement(StyledCard, null,
            React.createElement(HeaderWrapper, null,
                React.createElement(H4, { bold: true },
                    React.createElement(FormattedMessage, { id: "admin.reportingV2.popularPerks.title" })),
                React.createElement(PillWrapper, null, perks && React.createElement(Pill, { text: perks.length }))),
            React.createElement(ReactTable, { manual: false, getPaginationProps: function (allProps) { return (__assign(__assign({}, allProps), { shouldScrollOnUpdate: false })); }, page: page, pages: pages, onPageChange: this.handlePageChange, showPagination: pages > 1, data: perks, defaultPageSize: PAGE_SIZE, columns: columns(formatMessage, currency, isSavingsEnabled) })));
    };
    return MostPopularPerks;
}(Component));
export default injectIntl(MostPopularPerks);
